<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :rules="rules" :inline="true">
        <div class="block">
          <div class="contit">基础信息</div>
          <FormItem v-for="(c, i) in formCtrl" :key="`formCtrl_${c.keyName}_${i}_${!!c.disabled}`" :viewMode="c.viewMode" :config="c" :options="c.options"
            :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">运单信息</div>

          <FormItem v-for="(c, i) in formCtrlOrder.slice(0, 3)" :key="`formCtrl_${c.keyName}_${i}_${!!c.disabled}`" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />

          <div v-show="form.pricing_id != 5">
            <FormItem v-for="(c, i) in formCtrlOrder.slice(3)" :key="`formCtrl_${c.keyName}_${i}_${!!c.disabled}`" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />

            <!-- 亏吨重量控件 -->
            <span>
              <FormItem v-show="form.pricing_id == 1" :viewMode="kuitonCtrl.viewMode" :config="kuitonCtrl"
                :options="kuitonCtrl.options" :inputValue="form[kuitonCtrl.keyName]" @onChange="onChange" />
            </span>
          </div>
          
          <div>
            <FormItem v-for="(c, i) in formCtrlOrder2" :key="`formCtrl_${c.keyName}_${i}_${!!c.disabled}`" :viewMode="c.viewMode" :config="c"
              :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
          </div>
          <!-- 重量控件 -->
          <span v-if="form.pricing_id == 1">
            <FormItem v-for="(c, i) in formCtrlWeight" :key="`formCtrl_${c.keyName}_${i}_${!!c.disabled}`" :viewMode="c.viewMode" :config="c"
              :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
          </span>
        </div>

        <div class="block">
          <div class="contit">备注信息</div>
          <FormItem v-for="(c, i) in formCtrlTime" :key="`formCtrl_${c.keyName}_${i}_${!!c.disabled}`" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange">
            <template #end>
              <!-- 结款提醒组件 -->
              <PaymentSwitch v-show="form['repaytime']" :value="form['istime']" @onToggle="onToggle" />
            </template>
          </FormItem>

          <!-- 可变文本域备注 -->
          <FormItem v-for="(c, i) in formCtrl3" :key="`formCtrl_${c.keyName}_${i}_${!!c.disabled}`" :ref="'form3Item' + i" :viewMode="c.viewMode"
            :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" @onInput="onInput">
          </FormItem>
        </div>

        <ExtraFee :form="form" :formCtrl="formCtrlfee" @onChange="onChange" />
      </el-form>
    </div>

    <div class="btns">
      <SubmitBtn :editMode="true" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import orderViewMixin from "../orderViewMixin";
import hireMixin from "../hireMixin";

export default {
  mixins: [detailMixin, orderViewMixin, hireMixin],
  data() {
    return {
      baseUrl: 'order',
      breadcrumb: [
        { name: "运单管理", path: "/order/nocontract" },
        { name: "普通运单", path: "/order/nocontract/hire" },
        { name: "外协运单添加" },
      ],
      form: {
        cprice: undefined,
        dprice: undefined,
        inton: undefined,
        unton: undefined,
        invoice: undefined,
        uninvoice: undefined,
        pricing_id: null,
        kuiton: undefined,
        cmessage: null,
        insurance: null,
        fuel: null,
        exceeded: null,
      },
      rules: {
        cprice: [
          { required: true, message: "请填写公司单价", trigger: "blur" },
        ],
        dprice: [
          { required: true, message: "请填写司机单价", trigger: "blur" },
        ],
        inton: [
          { required: true, validator: this.checkInTon, trigger: "blur" },
        ],
        unton: [
          { required: true, validator: this.checkUnTon, trigger: "blur" },
        ],
        invoice: [
          { required: true, message: "请上传装货单", trigger: "blur" },
        ],
        uninvoice: [
          { required: true, message: "请上传卸货单", trigger: "blur" },
        ],
      },
      formCtrl: [
        {
          label: "运单编号",
          keyName: "order_num",
          err: "请填写运单编号",
          type: "text",
          viewMode: true,
        },
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
          viewMode: true,
        },
        {
          label: "承运公司",
          keyName: "pcustomname",
          err: "请填写承运公司",
          type: "text",
          viewMode: true,
        },
        {
          label: "客户名称",
          keyName: "shname",
          err: "请填写客户名称",
          type: "text",
          viewMode: true,
        },
        {
          label: "装货地址",
          keyName: "coaddress",
          err: "请填写装货地址",
          type: "text",
          viewMode: true,
        },
        {
          label: "卸货地址",
          keyName: "enaddress",
          err: "请填写卸货地址",
          type: "text",
          viewMode: true,
        },
        {
          label: "货物名称",
          keyName: "name",
          err: "请填写货物名称",
          type: "text",
          viewMode: true,
        },
        {
          ...this.ctrls.ZhuangHuoRiQi,
        },
        {
          ...this.ctrls.XieHuoRiQi,
        },
      ],
    };
  },
  methods: {},
  mounted() { },
};
</script>

<style lang="less" scoped>
.info_form {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 5px;
  border-radius: 5px;

  .contit {
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin: 0 auto 25px;
    padding: 0 21px;
    font-weight: bold;
    font-size: 18px;
    color: #343434;
  }

  /deep/ .el-form {
    margin-bottom: 20px;

    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      &.unton {
        width: 1000px;
      }

      &.block {
        width: 100%;
        padding-right: 0;
        margin-right: 0;
      }

      .el-input,
      .el-date-editor--daterange {
        width: 300px;
      }

      .el-form-item__content {
        .el-input {
          width: 300px;
        }

        .unit {
          color: #909399;
        }

        .switch {
          margin-left: 10px;

          .el-switch {
            display: block;

            .el-switch__core {
              margin: 2px auto;
              display: block;
            }

            &.inactive {
              .el-switch__core::after {
                content: '关';
                line-height: 17px;
                text-indent: 18px;
                color: #fff;
              }
            }

            &.active {
              .el-switch__core::after {
                content: '开';
                line-height: 17px;
                text-indent: -16px;
                color: #fff;
              }
            }
          }

          .txt {
            min-width: 50px;
            line-height: 16px;
            font-size: 12px;
            color: #909399;
            margin-top: 3px;
          }
        }
      }

    }
  }

  .el-form:last-child {
    margin-bottom: 0;
  }
}

.btns {
  margin: 40px 0 60px 180px;
}
</style>
